let loading
export function loadGoogleMaps() {
  if (window.google?.maps?.Map) return Promise.resolve()
  if (loading) return loading
  const url = document.querySelector('meta[name="google-maps-url"]')?.content
  if (!url) return Promise.resolve()
  loading = new Promise((resolve, reject) => {
    const fail = () => {
      window.googleMapsAuthFailed = true
      window.dispatchEvent(new Event("google-maps:error"))
      reject(new Error("Google Maps could not load"))
    }
    window.dispatchMapsEvent = () => {
      window.dispatchEvent(new Event("google-maps:ready"))
      resolve()
    }
    window.gm_authFailure = fail
    const script = document.createElement("script")
    script.src = url
    script.async = true
    script.nonce = document.querySelector('meta[name="csp-nonce"]')?.content || ""
    script.onerror = fail
    document.head.appendChild(script)
  })
  return loading
}
